import React from "react";
import {
  getMSFilterRenderedItemComponent,
  MSFilterItemProps,
  MSFilterRenderedItemProps,
} from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/utils";
import { ModelScreenerFilterItemType } from "@models/model-screener/enums/filterType";

export const MSTableFilterItem = ({
  item,
  itemPaths,
  itemSize,
  disabled,
}: MSFilterItemProps) => {
  const Element = getMSFilterRenderedItemComponent(
    item.filterType as ModelScreenerFilterItemType,
  );

  const compiledProps: MSFilterRenderedItemProps = {
    itemPaths,
    itemSize,
    item,
    disabled,
  };

  return Element && <Element {...compiledProps} />;
};
